import { render } from "./DeleteTargetDialog.vue?vue&type=template&id=41d6e64d"
import script from "./DeleteTargetDialog.vue?vue&type=script&lang=js"
export * from "./DeleteTargetDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__